import { useRef, useState } from "react";
import { useExplore } from "./useExplore";
import {
  exploreMethodBySlug,
  NewExploreInstructor,
  NewExploreInstructorsResponse,
  NewExplorePayload,
} from "types/api/new-explore";
import { RequestMeta } from "types/api";
import { useDebounce } from "@shared/hooks/useDebounce";
import newExploreApi from "@api/new-explore";
import { EXPLORE_SORT } from "enums/new-explore/explore-sort";
import useExplorePreloadedData from "@templates/new-explore/hooks/useExplorePreloadedData";

const useSearchInstructor = () => {
  const [value, setValue] = useState("");
  const { addFilter, removeFilterByValue } = useExplore();
  const [resultItem, setResultItem] = useState<NewExploreInstructor[]>([]);
  const [loading, setLoading] = useState(false);
  const { activeFilters } = useExplorePreloadedData();
  const instructorIds = activeFilters?.instructor_id?.filter_value || [];

  const api =
    useRef<RequestMeta<NewExploreInstructorsResponse, never, never>>(undefined);

  const resetApi = () => {
    if (api.current) {
      api.current.cancel();
      api.current = undefined;
    }
  };

  const debounceSearch = async (input: string) => {
    if (input.length < 2) {
      resetApi();
      setLoading(false);
    } else {
      search(input);
      setLoading(true);
    }
    setValue(input);
  };
  const onChangeDebounced = useDebounce(debounceSearch, 100);
  const search = async (e: string) => {
    resetApi();
    setResultItem([]);
    api.current = (
      newExploreApi[exploreMethodBySlug.instructor] as (
        // eslint-disable-next-line no-unused-vars
        params?: NewExplorePayload
      ) => RequestMeta<NewExploreInstructorsResponse, never, NewExplorePayload>
    )({ term: e, page: 1, count: 100, sort: EXPLORE_SORT.MOST_SOLD });

    const res = await api.current?.fetch();
    if (res.instructors.length) {
      setResultItem(res.instructors);
      setLoading(false);
    }
  };
  const handleClear = () => {
    resetApi();
    setResultItem([]);
    setValue("");
  };
  const handleSelectedInstructor = (id: string, checked: boolean) => {
    if (checked) {
      addFilter({ filterName: "instructor_id", value: id, name: "" });
    } else {
      removeFilterByValue("instructor_id", id);
    }
  };

  return {
    handleSelectedInstructor,
    handleClear,
    onChangeDebounced,
    value,
    setResultItem,
    loading,
    resultItem,
    instructorIds,
    search,
  };
};

export default useSearchInstructor;
